/* Las lindas – interacciones de las secciones propias */
(function () {
  if (window.__llInit) return;
  window.__llInit = true;
  document.documentElement.classList.add('ll-js');

  function initReveal() {
    var els = document.querySelectorAll('.ll-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el, i) {
      el.style.transitionDelay = (i % 3) * 80 + 'ms';
      io.observe(el);
    });
  }

  function initBeforeAfter() {
    document.querySelectorAll('[data-ll-ba]').forEach(function (box) {
      var r = box.querySelector('.ll-ba__range');
      if (!r || r.dataset.bound) return;
      r.dataset.bound = '1';
      var set = function () { box.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', set);
      set();
    });
  }

  function initBuy() {
    document.querySelectorAll('form.ll-form').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      form.addEventListener('submit', function (e) {
        var btn = e.submitter;
        var buyNow = btn && btn.hasAttribute('data-ll-buy');
        var rt = form.querySelector('input[name="return_to"]');
        if (buyNow) {
          if (!rt) {
            rt = document.createElement('input');
            rt.type = 'hidden'; rt.name = 'return_to';
            form.appendChild(rt);
          }
          rt.value = '/checkout';
          return; // envío normal: agrega y va directo al pago
        }
        if (rt) rt.remove();
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return; // sin carrito lateral: va a /cart
        e.preventDefault();
        if (btn) btn.setAttribute('aria-busy', 'true');
        var fd = new FormData(form);
        fd.append('sections', 'cart-drawer,cart-icon-bubble');
        fd.append('sections_url', window.location.pathname);
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { form.submit(); return; }
            drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
      });
    });
  }


  function initSlides() {
    document.querySelectorAll('[data-ll-slides]').forEach(function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      var track = box.querySelector('[data-ll-track]');
      var slides = track ? track.children : [];
      var dots = box.querySelectorAll('[data-ll-dot]');
      if (!track || slides.length < 2) return;
      var ms = parseInt(box.dataset.interval, 10) || 4000;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var cur = 0, timer = null, paused = false, visible = true;
      function go(i) {
        cur = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[cur].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      }
      function mark() {
        var best = 0, bd = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var d = Math.abs(slides[i].offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < bd) { bd = d; best = i; }
        }
        cur = best;
        dots.forEach(function (d, i) { d.setAttribute('aria-selected', i === best ? 'true' : 'false'); });
      }
      function tick() { if (!paused && visible && !document.hidden) go(cur + 1); }
      function start() { if (!reduce && !timer) timer = setInterval(tick, ms); }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      ['pointerdown', 'touchstart', 'focusin', 'mouseenter'].forEach(function (ev) { box.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { box.addEventListener(ev, function () { paused = false; }); });
      box.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 5000); }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0.3 }).observe(box);
      }
      start();
    });
  }

  function initReviews() {
    document.querySelectorAll('[data-ll-rev]').forEach(function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      var track = box.querySelector('[data-ll-rev-track]');
      var cards = track ? track.children : [];
      var dots = box.querySelectorAll('[data-ll-rev-dot]');
      if (!track || cards.length < 2) return;
      var ms = parseInt(box.dataset.interval, 10) || 5000;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null, paused = false, visible = true;
      function maxLeft() { return track.scrollWidth - track.clientWidth; }
      function atEnd() { return track.scrollLeft >= maxLeft() - 4; }
      function current() {
        if (atEnd()) return cards.length - 1;
        var best = 0, bd = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var d = Math.abs(cards[i].offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < bd) { bd = d; best = i; }
        }
        return best;
      }
      function go(i) {
        var left = Math.min(cards[i].offsetLeft - track.offsetLeft, maxLeft());
        track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
      }
      function mark() {
        var c = current();
        dots.forEach(function (d, i) { d.setAttribute('aria-selected', i === c ? 'true' : 'false'); });
      }
      function tick() {
        if (paused || !visible || document.hidden || maxLeft() < 4) return;
        go(atEnd() ? 0 : Math.min(current() + 1, cards.length - 1));
      }
      track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      ['pointerdown', 'touchstart', 'focusin', 'mouseenter'].forEach(function (ev) { box.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { box.addEventListener(ev, function () { paused = false; }); });
      box.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 5000); }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0.3 }).observe(box);
      }
      if (!reduce && !timer) timer = setInterval(tick, ms);
    });
  }

  function init() { initReveal(); initBeforeAfter(); initBuy(); initSlides(); initReviews(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
